<template>
    <div class="setting">
        <alert-component :status="alertStatus" v-show="alertShow" :alert-message="alertMessage"></alert-component>
        <span class="setting-label">{{ title }}</span>
        <form>
            <label v-for="option in options">
                <input type="radio" @click="saveSetting(option.value)" v-model="settingValue" :value="option.value">
                <span class="fake-input-label"></span>
                {{ option.label }}
            </label>
        </form>
    </div>
</template>

<script>
import axios from 'axios'
import Notifications from "../notifications";

export default {
    props: {
        setting: {
            required: true,
            type: String
        },
        currentSetting: {
            required: true
        },
        title: {
            required: true,
            type: String,
            default: ''
        },
        options: {
            required: true,
            validator: value => Array.isArray(value) && value.length > 0 && value.length === value.filter(
                option => (typeof option === 'object') && option.hasOwnProperty('value') && option.hasOwnProperty('label')
            ).length
        },
        errorMessage: {
            required: true,
            type: String,
            default: '',
        },
        successMessage: {
            required: true,
            type: String,
            default: '',
        }
    },
    data() {
        return {
            settingValue: 0,
            alertStatus: 'error',
            alertShow: false,
            alertMessage: ''
        }
    },
    methods: {
        saveSetting(value) {
            axios.post('/settings/video', {
                setting: this.setting,
                value: value
            }).then(() => {
                this.notifications.notify(this.successMessage);
            }).catch(() => {
                this.notifications.notify(this.errorMessage);
            });
        },
    },
    mounted() {
        this.settingValue = this.currentSetting
        this.notifications = new Notifications();
        this.notifications.setNotificationsPosition(document.querySelector('.setting:last-child').getBoundingClientRect().bottom - 50);
    }
}
</script>
